module.exports = __webpack_public_path__ + "static/media/CV.7b57e5cc.pdf";